import { createContext } from 'react';
import { UserDetailsResult } from './types';

/**
 * User context for providing user details throughout the application
 */
export const UserContext = createContext<UserDetailsResult>({
  userDetails: null,
  billedEntity: null,
  firstName: '',
  lastName: '',
  email: '',
  displayRole: '',
  isAdmin: false,
  isSystemAdmin: false,
  isLoading: false,
  error: null,
  refetchUserDetails: async () => {},
});
